import { AlertTriangle } from "lucide-react";
import { STORAGE_WARNING_COPY } from "../services/app/constants";
import type { StorageHealth } from "../services/app/storage";

interface StorageWarningProps {
  health: StorageHealth | undefined;
}

export function StorageWarning({ health }: StorageWarningProps): JSX.Element {
  if (!health) {
    return <p className="trust-line">{STORAGE_WARNING_COPY}</p>;
  }
  if (!health.lowStorage) {
    return <p className="trust-line">{STORAGE_WARNING_COPY}</p>;
  }
  return (
    <div className="notice notice--warning" role="status">
      <AlertTriangle size={18} aria-hidden="true" /> Storage is getting full. Export your PDF when finished.
    </div>
  );
}
